import { render, staticRenderFns } from "./ArticleList.vue?vue&type=template&id=c9c6c29c&"
import script from "./ArticleList.vue?vue&type=script&lang=js&"
export * from "./ArticleList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ArticleCard: require('/usr/src/app/components/article/ArticleCard.vue').default,CardLoading: require('/usr/src/app/components/common/CardLoading.vue').default})
